/**
 * PageCrumb — the ONE crumb line at the top of the content column:
 *
 *   Meridian Ventures › Portfolio          Personal › Sharing
 *   Personal › My inventions › Aurora Battery Cathode › Claims › Claim 2
 *
 * It replaces the two stacked breadcrumb rows the old shell put on every
 * graduated screen (the layout's "Personal › Innovations › Projects › Detail"
 * plus the page's own "Projects › <name>"). Reads the spec the page declared;
 * renders nothing otherwise, so ungraduated screens keep the old breadcrumbs.
 *
 * The last crumb is the page you are on: bold, dark, and never a link, so the
 * row says where you are as well as how you got here. Every figure draws it
 * that way, and the build used to draw all five identically.
 */
import { Link } from 'react-router-dom'
import { useSpine } from './useSpine'

export default function PageCrumb() {
  const spec = useSpine()
  const crumb = spec?.crumb
  if (!crumb || crumb.length === 0) return null
  return (
    <nav aria-label="Breadcrumb" className="mb-3 text-[12px] text-slate-500" data-testid="page-crumb">
      {crumb.map((c, i) => {
        const label = typeof c === 'string' ? c : c.label
        const plain = typeof c === 'string' ? false : c.plain === true
        const last = i === crumb.length - 1
        // The crumb you are ON is never a link, whatever the page declared:
        // the figures draw it bold and dark, and a page that cannot be
        // navigated to from itself should not offer to.
        const to = last ? undefined : (typeof c === 'string' ? undefined : c.to)
        return (
          <span key={`${label}-${i}`}>
            {i > 0 ? <span className="text-slate-400">{' \u203A '}</span> : null}
            {to ? (
              <Link to={to} className="font-normal text-iflow-600 hover:underline">
                {label}
              </Link>
            ) : plain ? (
              <span>{label}</span>
            ) : (
              <b
                className={last ? 'font-bold text-iflow-900' : 'font-normal text-iflow-600'}
                aria-current={last ? 'page' : undefined}
              >
                {label}
              </b>
            )}
          </span>
        )
      })}
    </nav>
  )
}
